import { jsx as e } from "react/jsx-runtime";
import { useTranslation as o } from "react-i18next";
import '../../assets/style5.css';/* empty css                   */
const l = ({ children: s, className: i, disabled: n, isLoading: t, ...r }) => {
  const { t: a } = o();
  return /* @__PURE__ */ e(
    "button",
    {
      ...r,
      "data-test": "login-submit-btn",
      className: `submit-btn override-submit-btn ${i ?? ""}`,
      type: "submit",
      disabled: n || t,
      children: t ? /* @__PURE__ */ e("p", { children: a("btn.please-wait", "Please wait...") }) : s
    }
  );
};
export {
  l as default
};
